// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* ===== Coming Soon Toast ===== */
.coming-soon-toast {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--accent-primary);
  color: white;
  padding: 12px 24px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  z-index: 200;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  animation: toastIn 0.3s ease-out;
  white-space: nowrap;
}

@keyframes toastIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-12px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* ===== Navigation ===== */
.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  border-bottom: 1px solid var(--border-primary);
  background: var(--bg-overlay);
  backdrop-filter: blur(10px);
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-primary);
  font-size: 18px;
  font-weight: 700;
}

.nav-logo {
  width: 32px;
  height: 32px;
  border-radius: 8px;
}

.nav-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.nav-icon-btn {
  background: transparent;
  border: none;
  color: var(--text-muted);
  text-decoration: none;
  font-size: 18px;
  padding: 8px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
}

.nav-icon-btn:hover {
  color: var(--text-primary);
  background: var(--bg-secondary);
}

.nav-icon-btn.active {
  color: var(--accent-primary);
}

/* ===== Settings Panel ===== */
.settings-backdrop {
  position: fixed;
  inset: 0;
  z-index: 90;
}

.settings-panel {
  position: sticky;
  top: 57px;
  z-index: 95;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-primary);
  padding: 16px 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  justify-content: center;
  animation: slideDown 0.2s ease-out;
}

.settings-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.settings-label {
  font-size: 13px;
  color: var(--text-muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.avatar-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.avatar-pick {
  background: transparent;
  border: 2px solid var(--border-secondary);
  border-radius: 10px;
  padding: 6px 10px;
  font-size: 22px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.avatar-pick:hover {
  border-color: var(--border-hover);
  transform: scale(1.1);
}

.avatar-pick.active {
  border-color: var(--accent-primary);
  background: var(--bg-tertiary);
}

/* ===== User / Sign-in button ===== */
.nav-user-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-secondary);
  border-radius: 50px;
  padding: 4px 12px 4px 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 600;
}

.nav-user-btn:hover {
  border-color: var(--border-hover);
}

.nav-user-avatar {
  font-size: 22px;
  line-height: 1;
}

.nav-user-name {
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sign-in-btn {
  color: var(--accent-primary) !important;
}

/* Sign-in pill (shown next to brand on left) */
.nav-sign-in-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}

.nav-sign-in-pill:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

.nav-sign-in-pill:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ===== Nickname Input ===== */
.nickname-input {
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
  border-radius: 8px;
  padding: 6px 12px;
  color: var(--text-primary);
  font-size: 14px;
  font-family: inherit;
  width: 140px;
  transition: border-color 0.2s ease;
}

.nickname-input:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.nickname-input::placeholder {
  color: var(--text-muted);
}

/* ===== Sync Hint & Status ===== */
.sync-hint {
  flex-direction: column;
  gap: 8px !important;
  padding: 8px 0;
}

.sync-hint-text {
  font-size: 12px;
  color: var(--text-muted);
  text-align: center;
}

.sync-sign-in-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sync-sign-in-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

.sync-sign-in-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sync-status {
  gap: 10px !important;
}

.sync-badge {
  font-size: 12px;
  color: #4CAF50;
  font-weight: 600;
}

.sync-sign-out-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid var(--border-secondary);
  border-radius: 50px;
  padding: 6px 12px;
  font-size: 12px;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.2s ease;
}

.sync-sign-out-btn:hover {
  border-color: var(--border-hover);
  color: var(--text-primary);
}

/* ===== Quick Bar (quick-start + stats) ===== */
.quick-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 16px 24px 0;
  max-width: 900px;
  margin: 0 auto;
  width: 100%;
  flex-wrap: wrap;
}

.quick-start {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: var(--accent-primary);
  color: white;
  border-radius: 50px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.quick-start:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.4);
}

.quick-icon {
  font-size: 12px;
}

.quick-stats {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-secondary);
  border-radius: 50px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  transition: all 0.2s ease;
}

.quick-stats:hover {
  border-color: var(--border-hover);
  transform: translateY(-2px);
}

/* ===== Disclaimer Bar ===== */
.disclaimer-bar {
  text-align: center;
  padding: 12px 24px;
  max-width: 900px;
  margin: 0 auto;
  width: 100%;
}

.disclaimer-bar span {
  font-size: 11px;
  color: var(--text-muted-dark);
  font-style: italic;
}

/* ===== Section Blocks ===== */
.section-block {
  max-width: 900px;
  margin: 0 auto;
  width: 100%;
  padding: 0 24px;
}

.section-block + .section-block {
  margin-top: 8px;
}

.section-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 20px 0 8px;
  border-bottom: 1px solid var(--border-primary);
  margin-bottom: 16px;
}

.section-label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-icon {
  font-size: 20px;
  line-height: 1;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.section-desc {
  font-size: 13px;
  color: var(--text-muted);
}

/* ===== Card Grid ===== */
.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 16px;
  padding-bottom: 16px;
}

.exercise-card {
  background: var(--bg-card);
  border: 2px solid var(--border-secondary);
  border-radius: 20px;
  padding: 24px 16px 20px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.exercise-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--card-accent, var(--accent-primary));
  border-radius: 20px 20px 0 0;
}

.exercise-card:hover {
  border-color: var(--card-accent, var(--accent-primary));
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.exercise-card:active {
  transform: scale(0.97);
}

.card-emoji {
  font-size: 40px;
  line-height: 1;
}

.card-name {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.3;
}

.card-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-muted);
  flex-wrap: wrap;
  justify-content: center;
}

.card-dot::before {
  content: '';
  display: inline-block;
  width: 3px;
  height: 3px;
  background: var(--text-muted);
  border-radius: 50%;
}

/* Self-test card variant */
.self-test-card {
  border-style: dashed;
}

/* ===== Footer ===== */
.footer {
  margin-top: auto;
  border-top: 1px solid var(--border-primary);
  padding: 20px 24px;
  text-align: center;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 8px;
}

.footer-links a {
  color: var(--text-muted);
  text-decoration: none;
  font-size: 13px;
  transition: color 0.2s ease;
}

.footer-links a:hover {
  color: var(--accent-primary);
}

.footer-text {
  color: var(--text-muted-dark);
  font-size: 12px;
  margin: 0;
}

/* ===== Animations ===== */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .top-nav {
    padding: 10px 16px;
  }

  .nav-left {
    gap: 8px;
  }

  .nav-brand {
    font-size: 16px;
    gap: 8px;
  }

  .nav-logo {
    width: 28px;
    height: 28px;
  }

  .sign-in-label {
    display: none;
  }

  .nav-sign-in-pill {
    padding: 6px 10px;
  }

  .section-block {
    padding: 0 16px;
  }

  .section-header {
    padding: 16px 0 6px;
  }

  .section-desc {
    display: none;
  }

  .card-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;
  }

  .exercise-card {
    padding: 20px 12px 16px;
    border-radius: 16px;
  }

  .card-emoji {
    font-size: 32px;
  }

  .card-name {
    font-size: 13px;
  }

  .settings-panel {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 12px 16px;
  }

  .settings-section {
    flex-wrap: wrap;
  }

  .avatar-pick {
    padding: 4px 8px;
    font-size: 20px;
  }

  .quick-bar {
    padding: 12px 16px 0;
  }
}

@media (max-width: 480px) {
  .App {
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }

  .top-nav {
    padding-top: max(10px, env(safe-area-inset-top));
  }

  .section-block {
    padding: 0 12px;
  }

  .card-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .exercise-card {
    padding: 16px 10px 14px;
  }

  .card-emoji {
    font-size: 28px;
  }

  .card-name {
    font-size: 12px;
  }

  .card-info {
    font-size: 11px;
  }

  .footer {
    padding-bottom: max(20px, env(safe-area-inset-bottom));
  }

  .nav-icon-btn {
    min-width: 44px;
    min-height: 44px;
  }

  .settings-panel {
    padding: 12px;
  }

  .avatar-pick {
    min-width: 40px;
    min-height: 40px;
    padding: 4px 6px;
    font-size: 18px;
  }

  .nickname-input {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,yCAAyC;EACzC,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,yCAAyC;EACzC,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;EACzC,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,uDAAuD;EACvD,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,uCAAuC;IACvC,yCAAyC;EAC3C;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".App {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ===== Coming Soon Toast ===== */\n.coming-soon-toast {\n  position: fixed;\n  top: 80px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--accent-primary);\n  color: white;\n  padding: 12px 24px;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: 600;\n  z-index: 200;\n  cursor: pointer;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n  animation: toastIn 0.3s ease-out;\n  white-space: nowrap;\n}\n\n@keyframes toastIn {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* ===== Navigation ===== */\n.top-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px;\n  border-bottom: 1px solid var(--border-primary);\n  background: var(--bg-overlay);\n  backdrop-filter: blur(10px);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.nav-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.nav-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--text-primary);\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.nav-logo {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n}\n\n.nav-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.nav-icon-btn {\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  text-decoration: none;\n  font-size: 18px;\n  padding: 8px;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  min-height: 40px;\n}\n\n.nav-icon-btn:hover {\n  color: var(--text-primary);\n  background: var(--bg-secondary);\n}\n\n.nav-icon-btn.active {\n  color: var(--accent-primary);\n}\n\n/* ===== Settings Panel ===== */\n.settings-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 90;\n}\n\n.settings-panel {\n  position: sticky;\n  top: 57px;\n  z-index: 95;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-primary);\n  padding: 16px 24px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n  animation: slideDown 0.2s ease-out;\n}\n\n.settings-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.settings-label {\n  font-size: 13px;\n  color: var(--text-muted);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.avatar-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.avatar-pick {\n  background: transparent;\n  border: 2px solid var(--border-secondary);\n  border-radius: 10px;\n  padding: 6px 10px;\n  font-size: 22px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.avatar-pick:hover {\n  border-color: var(--border-hover);\n  transform: scale(1.1);\n}\n\n.avatar-pick.active {\n  border-color: var(--accent-primary);\n  background: var(--bg-tertiary);\n}\n\n/* ===== User / Sign-in button ===== */\n.nav-user-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-secondary);\n  border-radius: 50px;\n  padding: 4px 12px 4px 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: var(--text-primary);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.nav-user-btn:hover {\n  border-color: var(--border-hover);\n}\n\n.nav-user-avatar {\n  font-size: 22px;\n  line-height: 1;\n}\n\n.nav-user-name {\n  max-width: 80px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sign-in-btn {\n  color: var(--accent-primary) !important;\n}\n\n/* Sign-in pill (shown next to brand on left) */\n.nav-sign-in-pill {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--accent-primary);\n  color: white;\n  border: none;\n  border-radius: 50px;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: inherit;\n}\n\n.nav-sign-in-pill:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);\n}\n\n.nav-sign-in-pill:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ===== Nickname Input ===== */\n.nickname-input {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-secondary);\n  border-radius: 8px;\n  padding: 6px 12px;\n  color: var(--text-primary);\n  font-size: 14px;\n  font-family: inherit;\n  width: 140px;\n  transition: border-color 0.2s ease;\n}\n\n.nickname-input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n}\n\n.nickname-input::placeholder {\n  color: var(--text-muted);\n}\n\n/* ===== Sync Hint & Status ===== */\n.sync-hint {\n  flex-direction: column;\n  gap: 8px !important;\n  padding: 8px 0;\n}\n\n.sync-hint-text {\n  font-size: 12px;\n  color: var(--text-muted);\n  text-align: center;\n}\n\n.sync-sign-in-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--accent-primary);\n  color: white;\n  border: none;\n  border-radius: 50px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.sync-sign-in-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);\n}\n\n.sync-sign-in-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.sync-status {\n  gap: 10px !important;\n}\n\n.sync-badge {\n  font-size: 12px;\n  color: #4CAF50;\n  font-weight: 600;\n}\n\n.sync-sign-out-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  border: 1px solid var(--border-secondary);\n  border-radius: 50px;\n  padding: 6px 12px;\n  font-size: 12px;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.sync-sign-out-btn:hover {\n  border-color: var(--border-hover);\n  color: var(--text-primary);\n}\n\n/* ===== Quick Bar (quick-start + stats) ===== */\n.quick-bar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 24px 0;\n  max-width: 900px;\n  margin: 0 auto;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.quick-start {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: var(--accent-primary);\n  color: white;\n  border-radius: 50px;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.quick-start:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.4);\n}\n\n.quick-icon {\n  font-size: 12px;\n}\n\n.quick-stats {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-secondary);\n  border-radius: 50px;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  transition: all 0.2s ease;\n}\n\n.quick-stats:hover {\n  border-color: var(--border-hover);\n  transform: translateY(-2px);\n}\n\n/* ===== Disclaimer Bar ===== */\n.disclaimer-bar {\n  text-align: center;\n  padding: 12px 24px;\n  max-width: 900px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.disclaimer-bar span {\n  font-size: 11px;\n  color: var(--text-muted-dark);\n  font-style: italic;\n}\n\n/* ===== Section Blocks ===== */\n.section-block {\n  max-width: 900px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 0 24px;\n}\n\n.section-block + .section-block {\n  margin-top: 8px;\n}\n\n.section-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  padding: 20px 0 8px;\n  border-bottom: 1px solid var(--border-primary);\n  margin-bottom: 16px;\n}\n\n.section-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.section-icon {\n  font-size: 20px;\n  line-height: 1;\n}\n\n.section-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.section-desc {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n/* ===== Card Grid ===== */\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 16px;\n  padding-bottom: 16px;\n}\n\n.exercise-card {\n  background: var(--bg-card);\n  border: 2px solid var(--border-secondary);\n  border-radius: 20px;\n  padding: 24px 16px 20px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.exercise-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--card-accent, var(--accent-primary));\n  border-radius: 20px 20px 0 0;\n}\n\n.exercise-card:hover {\n  border-color: var(--card-accent, var(--accent-primary));\n  transform: translateY(-4px) scale(1.02);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n}\n\n.exercise-card:active {\n  transform: scale(0.97);\n}\n\n.card-emoji {\n  font-size: 40px;\n  line-height: 1;\n}\n\n.card-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.3;\n}\n\n.card-info {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--text-muted);\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.card-dot::before {\n  content: '';\n  display: inline-block;\n  width: 3px;\n  height: 3px;\n  background: var(--text-muted);\n  border-radius: 50%;\n}\n\n/* Self-test card variant */\n.self-test-card {\n  border-style: dashed;\n}\n\n/* ===== Footer ===== */\n.footer {\n  margin-top: auto;\n  border-top: 1px solid var(--border-primary);\n  padding: 20px 24px;\n  text-align: center;\n}\n\n.footer-links {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 8px;\n}\n\n.footer-links a {\n  color: var(--text-muted);\n  text-decoration: none;\n  font-size: 13px;\n  transition: color 0.2s ease;\n}\n\n.footer-links a:hover {\n  color: var(--accent-primary);\n}\n\n.footer-text {\n  color: var(--text-muted-dark);\n  font-size: 12px;\n  margin: 0;\n}\n\n/* ===== Animations ===== */\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .top-nav {\n    padding: 10px 16px;\n  }\n\n  .nav-left {\n    gap: 8px;\n  }\n\n  .nav-brand {\n    font-size: 16px;\n    gap: 8px;\n  }\n\n  .nav-logo {\n    width: 28px;\n    height: 28px;\n  }\n\n  .sign-in-label {\n    display: none;\n  }\n\n  .nav-sign-in-pill {\n    padding: 6px 10px;\n  }\n\n  .section-block {\n    padding: 0 16px;\n  }\n\n  .section-header {\n    padding: 16px 0 6px;\n  }\n\n  .section-desc {\n    display: none;\n  }\n\n  .card-grid {\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    gap: 12px;\n  }\n\n  .exercise-card {\n    padding: 20px 12px 16px;\n    border-radius: 16px;\n  }\n\n  .card-emoji {\n    font-size: 32px;\n  }\n\n  .card-name {\n    font-size: 13px;\n  }\n\n  .settings-panel {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    padding: 12px 16px;\n  }\n\n  .settings-section {\n    flex-wrap: wrap;\n  }\n\n  .avatar-pick {\n    padding: 4px 8px;\n    font-size: 20px;\n  }\n\n  .quick-bar {\n    padding: 12px 16px 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .App {\n    padding-left: env(safe-area-inset-left);\n    padding-right: env(safe-area-inset-right);\n  }\n\n  .top-nav {\n    padding-top: max(10px, env(safe-area-inset-top));\n  }\n\n  .section-block {\n    padding: 0 12px;\n  }\n\n  .card-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n\n  .exercise-card {\n    padding: 16px 10px 14px;\n  }\n\n  .card-emoji {\n    font-size: 28px;\n  }\n\n  .card-name {\n    font-size: 12px;\n  }\n\n  .card-info {\n    font-size: 11px;\n  }\n\n  .footer {\n    padding-bottom: max(20px, env(safe-area-inset-bottom));\n  }\n\n  .nav-icon-btn {\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  .settings-panel {\n    padding: 12px;\n  }\n\n  .avatar-pick {\n    min-width: 40px;\n    min-height: 40px;\n    padding: 4px 6px;\n    font-size: 18px;\n  }\n\n  .nickname-input {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
